import { render, staticRenderFns } from "./edit-likert.vue?vue&type=template&id=044046ba&"
import script from "./edit-likert.vue?vue&type=script&lang=ts&"
export * from "./edit-likert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports